import React from 'react'
import {ReactQueryDevtools} from 'react-query/devtools'

import {ConfigCatProvider, createConsoleLogger, LogLevel} from 'configcat-react'
import {BUGSNAG_STAGE, CONFIGCAT_CE_FLAGS_SDK_KEY} from '../constants'
import {IS_DEVELOPMENT} from '../config'
import {AuthProvider} from '../stores/AuthStore'
import {ConfirmationProvider} from './ConfirmationManager'
import {SSEProvider} from './SSEProvider'
import {SessionRefresher} from './SessionRefresher'

export const AppProviders: React.FC<React.PropsWithChildren> = ({children}) => {
  const logLevel =
    BUGSNAG_STAGE === 'production' ? LogLevel.Error : LogLevel.Info

  const logger = createConsoleLogger(logLevel) // Set the log level to INFO to track how your feature flags were evaluated. When moving to production, you can remove this line to avoid too detailed logging.

  return (
    <ConfigCatProvider sdkKey={CONFIGCAT_CE_FLAGS_SDK_KEY} options={{logger}}>
      <AuthProvider>
        <SSEProvider>
          <ConfirmationProvider>
            <SessionRefresher />
            {children}
            {IS_DEVELOPMENT && (
              <ReactQueryDevtools
                initialIsOpen={false}
                position='bottom-right'
              />
            )}
          </ConfirmationProvider>
        </SSEProvider>
      </AuthProvider>
    </ConfigCatProvider>
  )
}
